// @flow
import React from "react";
import { withRouter } from "react-router-dom";

import DetailsView from "buba-components/src/views/Details";
import DetailsViewNew from "buba-components/src/views/Details/DetailsNew";

import savePdf from "buba-components/src/utils/savePdf";
import statusErrors from "buba-components/src/data/statusErrors";
import { bankInquiryTabs, bankInquiryTabsNew } from "../../data/navLinks";
import paths from "../../data/paths";
import { getDetailsInformationForBankAdvisorInquiry, downloadOkpSummary } from "../../api/actions";
import { getInquiryV2 } from "../../api/v2actions";

type BankInquiryDetailsProps = {
  match: {
    params: {
      id: number
    }
  },
  isV2?: boolean
};

const BankInquiryDetails = ({ match, isV2 }: BankInquiryDetailsProps) => {
  const downloadPdf = async (okpUid: string, addMessage: (msg: string, type: string) => void) => {
    if (okpUid) {
      try {
        const response = await downloadOkpSummary(okpUid);

        savePdf(response.data, okpUid);
      } catch (err) {
        addMessage(statusErrors(err.status), "failure");
      }
    }
  };

  return isV2 ? (
    <DetailsViewNew
      match={match}
      getTabs={(inquiryType, financingProcess) => id => bankInquiryTabsNew(id, financingProcess)}
      backPath={() => paths.bankInquiriesList}
      getInquiry={getInquiryV2}
      downloadPdf={downloadPdf}
      site="bank"
    />
  ) : (
    // TODO(v1-removal): V1 branch - unreachable after V1 routes redirect to V2. Delete along with DetailsView, bankInquiryTabs, getDetailsInformationForBankAdvisorInquiry.
    <DetailsView
      match={match}
      getTabs={() => bankInquiryTabs}
      backPath={() => paths.bankInquiriesList}
      getInquiry={getDetailsInformationForBankAdvisorInquiry}
      downloadPdf={downloadPdf}
      site="bank"
    />
  );
};

export default withRouter(BankInquiryDetails);
